import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { login, logout } from "../auth/authClient";
import { Footer } from "../../platform/components/Footer";
import logoUrl from "../../assets/logo.png";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About Madinet Masr", end: false },
  { to: "/gym", label: "Schedule", end: true },
  { to: "/gym/bookings", label: "My Bookings", end: false },
  { to: "/gym/profile", label: "Profile", end: false },
];

export function AppLayout() {
  const { principal, isAuthenticated, isCoach, isAdmin } = useAuth();

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="brand">
          <img className="brand-logo" src={logoUrl} alt="Madinet Masr" />
          <div>
            <div className="brand-title">Madinet Masr</div>
            <div className="brand-sub">Gym</div>
          </div>
        </Link>

        <nav className="app-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            >
              {item.label}
            </NavLink>
          ))}
          {isCoach && (
            <NavLink
              to="/gym/coach"
              className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            >
              Check-in
            </NavLink>
          )}
          {isAdmin && (
            <NavLink
              to="/gym/admin"
              className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            >
              Admin
            </NavLink>
          )}
        </nav>

        <div className="app-account">
          {isAuthenticated ? (
            <>
              <span className="account-email">{principal?.userDetails}</span>
              <button className="btn btn-ghost" onClick={logout}>
                Sign out
              </button>
            </>
          ) : (
            <button className="btn btn-primary" onClick={() => login()}>
              Sign in
            </button>
          )}
        </div>
      </header>

      <main className="app-main">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
